import React from 'react';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = ['Alle 10 Bände komplett (Band 1–10)', 'Stunden, Arbeitsblätter und Kopiervorlagen für jede Klassenstufe', 'Lehrer-Skripte und Bildfolgen, leicht nachvollziehbar', 'Fertige Vertretungsstunden – 3 in jedem Band', 'Sofort einsetzbar – zum Ausdrucken oder digital am Whiteboard', 'Drucke so oft du willst – nie wieder Materialsuche'];
export function InstantAccessSection() {
  return <section className="bg-brand-alt px-5 py-16 md:py-24" data-id="element-91" data-mp="1reoqtoo21n42">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-92" data-mp="1rg85xbxz5s49">
        <h2 className="mb-10 flex items-center justify-center gap-3 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-93" data-mp="25cdcuztuz0ap">
          <DownloadIcon className="h-7 w-7 shrink-0 text-brand-orange" strokeWidth={1.5} aria-hidden="true" data-id="element-94" data-mp="20fd2icpz7bds" />
          Was bekommst du sofort?
        </h2>
        <ul className="space-y-4 rounded-xl border border-brand-line bg-brand-main p-7 text-left shadow-sm md:p-10" data-id="element-95" data-mp="62nay1n2ye9k">
          {items.map(item => <li key={item} className="flex items-start gap-4" data-id="element-96" data-mp="2rzypw7va057o">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange" data-id="element-97" data-mp="2ryfasklcw07h">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-98" data-mp="31rmlmkyv88ey" />
              </span>
              <span className="text-sm font-semibold leading-snug md:text-base" data-id="element-99" data-mp="3aqq53q1y2ptz">
                {item}
              </span>
            </li>)}
        </ul>
        <p className="mt-10 text-xl italic text-brand-orange md:text-2xl" data-id="element-100" data-mp="3fo9m2xq11gpm">
          Dir geht nie wieder das Material aus.
        </p>
      </Reveal>
    </section>;
}